const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandingImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.91,278.32s-13.86,10-21.23,24.27-14.3,46.36-23.39,61.52S269,390.54,260.29,397s-21.66,10.83-29,12.13-27.3,3.47-27.3,3.47l.87,16.46s16.9.44,49-2.6,71.06-26.43,71.06-26.43l-1.3,48.1H435.33s6.93-68.46,3.47-103.56S415.4,284,398.5,274.42s-34.66-7.36-45.49-6.5S330.91,278.32,330.91,278.32Z",
    style: {
      fill: "#616161",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.37,208.18s0,18.7,1,22.64,7.55,22.63,9.19,27.88,14.43,28.53,17.38,32.14,15.74-5.25,15.74-5.25l7.22,15.75s15.59-25.88,19.2-32.12,5.65-13.12,3-23-2.88-10.2-19.28-18.07-40.34-17.05-44.93-20.33S290,205.89,289.37,208.18Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.42,206.8s29.32,17,48.77,25.45,44.22,21.67,46,32.72-10.61,21.23-15.47,25.2-14.6,13.71-14.6,13.71,23.88-13.26,32.28-19.45,11.5-16.81,8-35.82-5.75-48.2-16.36-64.56-36.7-7.52-55.71.88A125.47,125.47,0,0,0,276.42,206.8Z",
    style: {
      fill: "#616161",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395,294.79s-13,0-20.8,21.23-16.46,75-16.46,75-19.07,14.74-33.37,21.67A250.61,250.61,0,0,1,300.15,423s6.68,13.46,6.07,18.63c-.22,1.83,2.15,4.38,2.15,4.38s36-2.65,56.34-6.55,45.49-13,49-31.63,17.73-60.29,12.1-71.56",
    style: {
      fill: "#616161",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.16,476s75.68,12.15,135.06-41S438.91,295.24,454,225.59,437,94,377.86,74.15s-84.75,30.64-157.73,46.6-95.18,9-146.47,62.71S34.19,339.05,99.18,403.84,228.16,476,228.16,476Z",
    style: {
      fill: "#51C4DF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.16,476s75.68,12.15,135.06-41S438.91,295.24,454,225.59,437,94,377.86,74.15s-84.75,30.64-157.73,46.6-95.18,9-146.47,62.71S34.19,339.05,99.18,403.84,228.16,476,228.16,476Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lamp--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.83,120c-2.82-9.2-14-13.76-22-17.2-3.73-1.62-4.8-4.51-5.07-8.45,0-.43,0-3,.1-5.46H383.07c.07,2.49.12,5,.09,5.46-.27,3.94-1.34,6.83-5.07,8.45-7.95,3.44-19.15,8-22,17.2a22.17,22.17,0,0,0-1,7.15h71.72A22.17,22.17,0,0,0,425.83,120Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.9,
    y: 37.89,
    width: 2.14,
    height: 52.47,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 353.84,
    y1: 132.2,
    x2: 339.52,
    y2: 165.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 427.97,
    y1: 132.2,
    x2: 442.29,
    y2: 165.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 361.99,
    y1: 130.95,
    x2: 358.19,
    y2: 143.86,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.91,
    y1: 131.52,
    x2: 422.7,
    y2: 144.24,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 414.92,
    y1: 139.68,
    x2: 418.15,
    y2: 151.64,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 377.92,
    y1: 139.68,
    x2: 376.41,
    y2: 150.88,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icons--inject-3"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "185.9 154.4 211.22 154.4 211.22 178.64 183.73 178.64",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "215.93 204.15 235.1 204.15 235.1 165.25 217.01 165.25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.6,
    y: 150.42,
    width: 15.92,
    height: 9.05,
    style: {
      fill: "#51C4DF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 161.27,
    width: 15.92,
    height: 9.05,
    style: {
      fill: "#51C4DF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.97,
    y: 199.62,
    width: 15.92,
    height: 9.05,
    style: {
      fill: "#51C4DF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.6,
    y: 172.13,
    width: 15.92,
    height: 9.05,
    style: {
      fill: "#51C4DF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.11,
    y: 224.52,
    width: 65.33,
    height: 38.67,
    rx: 3.67,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.11,
    y: 231.85,
    width: 65.33,
    height: 14,
    style: {
      fill: "#51C4DF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.65,257a2.73,2.73,0,1,0-2.73,2.73A2.73,2.73,0,0,0,237.65,257Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.24,257a2.73,2.73,0,1,0-2.73,2.73A2.73,2.73,0,0,0,245.24,257Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.31,
    y: 188.58,
    width: 78.17,
    height: 40.73,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.31,
    y: 188.58,
    width: 78.17,
    height: 7.22,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.07,
    y: 204.47,
    width: 54.64,
    height: 11.68,
    style: {
      fill: "#51C4DF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.42,208.37h.94l-.14,1.6,1.32-1,.48.81-1.51.74,1.51.78-.48.82-1.32-1,.14,1.63h-.94L98.6,211l-1.33,1-.47-.82,1.46-.74-1.5-.7.48-.81,1.35,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.05,208.37H105l-.14,1.6,1.33-1,.47.81-1.5.74,1.5.78-.47.82-1.33-1,.14,1.63h-.93l.17-1.66-1.33,1-.47-.82,1.47-.74-1.5-.7.47-.81,1.36,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.67,208.37h.94l-.14,1.6,1.32-1,.48.81-1.51.74,1.51.78-.48.82-1.32-1,.14,1.63h-.94l.18-1.66-1.33,1-.47-.82,1.46-.74-1.5-.7.48-.81,1.35,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.3,208.37h.93l-.14,1.6,1.33-1,.47.81-1.5.74,1.5.78-.47.82-1.33-1,.14,1.63h-.93l.17-1.66-1.33,1-.47-.82,1.47-.74-1.5-.7.47-.81,1.36,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.92,208.37h.94l-.14,1.6,1.32-1,.48.81-1.51.74,1.51.78-.48.82-1.32-1,.14,1.63h-.94l.18-1.66-1.33,1-.47-.82,1.46-.74-1.5-.7.48-.81,1.35,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.55,208.37h.93l-.14,1.6,1.33-1,.47.81-1.5.74,1.5.78-.47.82-1.33-1,.14,1.63h-.93l.17-1.66-1.33,1-.47-.82,1.47-.74-1.5-.7.47-.81,1.36,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.17,208.37h.94L133,210l1.32-1,.48.81-1.51.74,1.51.78-.48.82-1.32-1,.14,1.63h-.94l.18-1.66-1.33,1-.47-.82,1.46-.74-1.5-.7L131,209l1.35,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.8,208.37h.93l-.14,1.6,1.33-1,.47.81-1.5.74,1.5.78-.47.82-1.33-1,.14,1.63h-.93L138,211l-1.33,1-.47-.82,1.47-.74-1.5-.7.47-.81,1.36,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.42,208.37h.94l-.14,1.6,1.32-1,.48.81-1.51.74,1.51.78-.48.82-1.32-1,.14,1.63h-.94l.18-1.66-1.33,1-.47-.82,1.46-.74-1.5-.7.48-.81,1.35,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 251.75,
    y1: 177.91,
    x2: 266.58,
    y2: 177.91,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 251.75,
    y1: 182.26,
    x2: 266.58,
    y2: 182.26,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 251.75,
    y1: 186.6,
    x2: 266.58,
    y2: 186.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 251.75,
    y1: 190.94,
    x2: 266.58,
    y2: 190.94,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.72,
    y1: 238.16,
    x2: 175.55,
    y2: 238.16,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.72,
    y1: 242.5,
    x2: 175.55,
    y2: 242.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.72,
    y1: 246.85,
    x2: 175.55,
    y2: 246.85,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.72,
    y1: 251.19,
    x2: 175.55,
    y2: 251.19,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.39,
    y1: 235.59,
    x2: 124.97,
    y2: 235.59,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.39,
    y1: 239.93,
    x2: 124.97,
    y2: 239.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.39,
    y1: 244.27,
    x2: 124.97,
    y2: 244.27,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.39,
    y1: 248.61,
    x2: 124.97,
    y2: 248.61,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-2--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 210.94,
    y: 409.82,
    width: 9.88,
    height: 37.64,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.39,
    y: 409.82,
    width: 12.97,
    height: 27.33,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.42,
    y: 284.6,
    width: 163.58,
    height: 127.95,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.18,
    y: 291.44,
    width: 146.08,
    height: 114.26,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.07,299.3h-3.76a.93.93,0,1,1,0-1.85h3.76a.93.93,0,1,1,0,1.85Zm.93,3.38a.93.93,0,0,0-.93-.93h-3.76a.93.93,0,0,0,0,1.86h3.76A.93.93,0,0,0,160,302.68Zm0,4.3a.93.93,0,0,0-.93-.93h-3.76a.93.93,0,0,0,0,1.86h3.76A.92.92,0,0,0,160,307Zm0,4.31a.92.92,0,0,0-.93-.93h-3.76a.93.93,0,1,0,0,1.85h3.76A.92.92,0,0,0,160,311.29Zm0,4.3a.93.93,0,0,0-.93-.93h-3.76a.93.93,0,0,0,0,1.86h3.76A.93.93,0,0,0,160,315.59Zm0,4.3a.93.93,0,0,0-.93-.93h-3.76a.93.93,0,0,0,0,1.86h3.76A.92.92,0,0,0,160,319.89Zm0,4.31a.92.92,0,0,0-.93-.93h-3.76a.93.93,0,1,0,0,1.85h3.76A.92.92,0,0,0,160,324.2Zm0,4.3a.93.93,0,0,0-.93-.93h-3.76a.93.93,0,0,0,0,1.86h3.76A.93.93,0,0,0,160,328.5Zm14.09-30.12a.93.93,0,0,0-.93-.93h-9.88a.93.93,0,1,0,0,1.85h9.88A.93.93,0,0,0,174.09,298.38Zm0,4.3a.93.93,0,0,0-.93-.93h-9.88a.93.93,0,1,0,0,1.86h9.88A.93.93,0,0,0,174.09,302.68Zm0,4.3a.93.93,0,0,0-.93-.93h-9.88a.93.93,0,0,0,0,1.86h9.88A.93.93,0,0,0,174.09,307Zm0,4.31a.93.93,0,0,0-.93-.93h-9.88a.93.93,0,1,0,0,1.85h9.88A.93.93,0,0,0,174.09,311.29Zm0,4.3a.93.93,0,0,0-.93-.93h-9.88a.93.93,0,0,0,0,1.86h9.88A.93.93,0,0,0,174.09,315.59Zm11.83,4.3A.93.93,0,0,0,185,319h-9.88a.93.93,0,0,0,0,1.86H185A.92.92,0,0,0,185.92,319.89Zm0,4.31a.92.92,0,0,0-.93-.93h-9.88a.93.93,0,1,0,0,1.85H185A.92.92,0,0,0,185.92,324.2Zm0,4.3a.93.93,0,0,0-.93-.93h-9.88a.93.93,0,0,0,0,1.86H185A.93.93,0,0,0,185.92,328.5Zm-7.48-30.12a1.08,1.08,0,1,0-1.08,1.07A1.08,1.08,0,0,0,178.44,298.38Zm3.23,0a1.08,1.08,0,1,0-1.08,1.07A1.08,1.08,0,0,0,181.67,298.38Zm3.22,0a1.08,1.08,0,1,0-1.07,1.07A1.07,1.07,0,0,0,184.89,298.38Zm3.23,0a1.08,1.08,0,1,0-1.08,1.07A1.08,1.08,0,0,0,188.12,298.38Zm3.23,0a1.08,1.08,0,1,0-1.08,1.07A1.08,1.08,0,0,0,191.35,298.38Zm3.23,0a1.08,1.08,0,1,0-1.08,1.07A1.08,1.08,0,0,0,194.58,298.38ZM178.44,307a1.08,1.08,0,1,0-1.08,1.08A1.07,1.07,0,0,0,178.44,307Zm3.23,0a1.08,1.08,0,1,0-1.08,1.08A1.08,1.08,0,0,0,181.67,307Zm3.22,0a1.08,1.08,0,1,0-1.07,1.08A1.07,1.07,0,0,0,184.89,307Zm3.23,0a1.08,1.08,0,1,0-1.08,1.08A1.07,1.07,0,0,0,188.12,307Zm3.23,0a1.08,1.08,0,1,0-1.08,1.08A1.07,1.07,0,0,0,191.35,307Zm3.23,0a1.08,1.08,0,1,0-1.08,1.08A1.08,1.08,0,0,0,194.58,307Zm-5.11,12.37a1.08,1.08,0,1,0-1.08,1.08A1.08,1.08,0,0,0,189.47,319.35Zm3.22,0a1.08,1.08,0,1,0-1.07,1.08A1.07,1.07,0,0,0,192.69,319.35Zm3.23,0a1.08,1.08,0,1,0-1.08,1.08A1.07,1.07,0,0,0,195.92,319.35Zm3.23,0a1.08,1.08,0,1,0-1.08,1.08A1.07,1.07,0,0,0,199.15,319.35Zm3.22,0a1.08,1.08,0,1,0-1.07,1.08A1.07,1.07,0,0,0,202.37,319.35Zm3.23,0a1.08,1.08,0,1,0-1.07,1.08A1.07,1.07,0,0,0,205.6,319.35Zm-16.13,8.88a1.08,1.08,0,1,0-1.08,1.08A1.09,1.09,0,0,0,189.47,328.23Zm3.22,0a1.08,1.08,0,1,0-1.07,1.08A1.08,1.08,0,0,0,192.69,328.23Zm3.23,0a1.08,1.08,0,1,0-1.08,1.08A1.08,1.08,0,0,0,195.92,328.23Zm3.23,0a1.08,1.08,0,1,0-1.08,1.08A1.08,1.08,0,0,0,199.15,328.23Zm3.22,0a1.08,1.08,0,1,0-1.07,1.08A1.08,1.08,0,0,0,202.37,328.23Zm3.23,0a1.08,1.08,0,1,0-1.07,1.08A1.08,1.08,0,0,0,205.6,328.23Z",
    style: {
      fill: "#51C4DF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.07,333.74h-3.76a.93.93,0,0,1,0-1.86h3.76a.93.93,0,0,1,0,1.86Zm.93,3.37a.92.92,0,0,0-.93-.92h-3.76a.93.93,0,1,0,0,1.85h3.76A.92.92,0,0,0,160,337.11Zm0,4.31a.92.92,0,0,0-.93-.93h-3.76a.93.93,0,0,0,0,1.86h3.76A.93.93,0,0,0,160,341.42Zm0,4.3a.93.93,0,0,0-.93-.93h-3.76a.93.93,0,0,0,0,1.86h3.76A.93.93,0,0,0,160,345.72Zm0,4.3a.93.93,0,0,0-.93-.93h-3.76a.93.93,0,0,0,0,1.86h3.76A.92.92,0,0,0,160,350Zm0,4.31a.92.92,0,0,0-.93-.93h-3.76a.93.93,0,0,0,0,1.86h3.76A.93.93,0,0,0,160,354.33Zm0,4.3a.93.93,0,0,0-.93-.93h-3.76a.93.93,0,0,0,0,1.86h3.76A.93.93,0,0,0,160,358.63Zm0,4.3a.93.93,0,0,0-.93-.93h-3.76a.93.93,0,0,0,0,1.86h3.76A.92.92,0,0,0,160,362.93Zm14.09-30.12a.93.93,0,0,0-.93-.93h-9.88a.93.93,0,1,0,0,1.86h9.88A.93.93,0,0,0,174.09,332.81Zm0,4.3a.93.93,0,0,0-.93-.92h-9.88a.93.93,0,1,0,0,1.85h9.88A.93.93,0,0,0,174.09,337.11Zm0,4.31a.93.93,0,0,0-.93-.93h-9.88a.93.93,0,1,0,0,1.86h9.88A.93.93,0,0,0,174.09,341.42Zm0,4.3a.93.93,0,0,0-.93-.93h-9.88a.93.93,0,0,0,0,1.86h9.88A.93.93,0,0,0,174.09,345.72Zm0,4.3a.93.93,0,0,0-.93-.93h-9.88a.93.93,0,0,0,0,1.86h9.88A.93.93,0,0,0,174.09,350Zm11.83,4.31a.92.92,0,0,0-.93-.93h-9.88a.93.93,0,1,0,0,1.86H185A.93.93,0,0,0,185.92,354.33Zm0,4.3a.93.93,0,0,0-.93-.93h-9.88a.93.93,0,0,0,0,1.86H185A.93.93,0,0,0,185.92,358.63Zm0,4.3A.93.93,0,0,0,185,362h-9.88a.93.93,0,1,0,0,1.86H185A.92.92,0,0,0,185.92,362.93Zm-7.48-30.12a1.08,1.08,0,1,0-1.08,1.08A1.08,1.08,0,0,0,178.44,332.81Zm3.23,0a1.08,1.08,0,1,0-1.08,1.08A1.09,1.09,0,0,0,181.67,332.81Zm3.22,0a1.08,1.08,0,1,0-1.07,1.08A1.08,1.08,0,0,0,184.89,332.81Zm3.23,0a1.08,1.08,0,1,0-1.08,1.08A1.08,1.08,0,0,0,188.12,332.81Zm3.23,0a1.08,1.08,0,1,0-1.08,1.08A1.08,1.08,0,0,0,191.35,332.81Zm3.23,0a1.08,1.08,0,1,0-1.08,1.08A1.09,1.09,0,0,0,194.58,332.81Zm-16.14,8.61a1.08,1.08,0,1,0-1.08,1.07A1.08,1.08,0,0,0,178.44,341.42Zm3.23,0a1.08,1.08,0,1,0-1.08,1.07A1.08,1.08,0,0,0,181.67,341.42Zm3.22,0a1.08,1.08,0,1,0-1.07,1.07A1.07,1.07,0,0,0,184.89,341.42Zm3.23,0a1.08,1.08,0,1,0-1.08,1.07A1.08,1.08,0,0,0,188.12,341.42Zm3.23,0a1.08,1.08,0,1,0-1.08,1.07A1.08,1.08,0,0,0,191.35,341.42Zm3.23,0a1.08,1.08,0,1,0-1.08,1.07A1.08,1.08,0,0,0,194.58,341.42Zm-5.11,12.37a1.08,1.08,0,1,0-1.08,1.07A1.08,1.08,0,0,0,189.47,353.79Zm3.22,0a1.08,1.08,0,1,0-1.07,1.07A1.07,1.07,0,0,0,192.69,353.79Zm3.23,0a1.08,1.08,0,1,0-1.08,1.07A1.08,1.08,0,0,0,195.92,353.79Zm3.23,0a1.08,1.08,0,1,0-1.08,1.07A1.08,1.08,0,0,0,199.15,353.79Zm3.22,0a1.08,1.08,0,1,0-1.07,1.07A1.07,1.07,0,0,0,202.37,353.79Zm3.23,0a1.08,1.08,0,1,0-1.07,1.07A1.07,1.07,0,0,0,205.6,353.79Zm-16.13,8.87a1.08,1.08,0,1,0-1.08,1.08A1.08,1.08,0,0,0,189.47,362.66Zm3.22,0a1.08,1.08,0,1,0-1.07,1.08A1.07,1.07,0,0,0,192.69,362.66Zm3.23,0a1.08,1.08,0,1,0-1.08,1.08A1.07,1.07,0,0,0,195.92,362.66Zm3.23,0a1.08,1.08,0,1,0-1.08,1.08A1.07,1.07,0,0,0,199.15,362.66Zm3.22,0a1.08,1.08,0,1,0-1.07,1.08A1.07,1.07,0,0,0,202.37,362.66Zm3.23,0a1.08,1.08,0,1,0-1.07,1.08A1.07,1.07,0,0,0,205.6,362.66Z",
    style: {
      fill: "#51C4DF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.07,369h-3.76a.93.93,0,0,1,0-1.86h3.76a.93.93,0,0,1,0,1.86Zm.93,3.37a.93.93,0,0,0-.93-.93h-3.76a.93.93,0,0,0,0,1.86h3.76A.93.93,0,0,0,160,372.38Zm0,4.3a.93.93,0,0,0-.93-.93h-3.76a.93.93,0,0,0,0,1.86h3.76A.92.92,0,0,0,160,376.68Zm0,4.31a.92.92,0,0,0-.93-.93h-3.76a.93.93,0,1,0,0,1.85h3.76A.92.92,0,0,0,160,381Zm0,4.3a.93.93,0,0,0-.93-.93h-3.76a.93.93,0,0,0,0,1.86h3.76A.93.93,0,0,0,160,385.29Zm0,4.3a.93.93,0,0,0-.93-.93h-3.76a.93.93,0,0,0,0,1.86h3.76A.92.92,0,0,0,160,389.59Zm0,4.31a.92.92,0,0,0-.93-.93h-3.76a.93.93,0,1,0,0,1.85h3.76A.92.92,0,0,0,160,393.9Zm0,4.3a.93.93,0,0,0-.93-.93h-3.76a.93.93,0,0,0,0,1.86h3.76A.93.93,0,0,0,160,398.2Zm14.09-30.12a.93.93,0,0,0-.93-.93h-9.88a.93.93,0,1,0,0,1.86h9.88A.93.93,0,0,0,174.09,368.08Zm0,4.3a.93.93,0,0,0-.93-.93h-9.88a.93.93,0,0,0,0,1.86h9.88A.93.93,0,0,0,174.09,372.38Zm0,4.3a.93.93,0,0,0-.93-.93h-9.88a.93.93,0,0,0,0,1.86h9.88A.93.93,0,0,0,174.09,376.68Zm0,4.31a.93.93,0,0,0-.93-.93h-9.88a.93.93,0,1,0,0,1.85h9.88A.93.93,0,0,0,174.09,381Zm0,4.3a.93.93,0,0,0-.93-.93h-9.88a.93.93,0,1,0,0,1.86h9.88A.93.93,0,0,0,174.09,385.29Zm11.83,4.3a.93.93,0,0,0-.93-.93h-9.88a.93.93,0,0,0,0,1.86H185A.92.92,0,0,0,185.92,389.59Zm0,4.31A.92.92,0,0,0,185,393h-9.88a.93.93,0,1,0,0,1.85H185A.92.92,0,0,0,185.92,393.9Zm0,4.3a.93.93,0,0,0-.93-.93h-9.88a.93.93,0,1,0,0,1.86H185A.93.93,0,0,0,185.92,398.2Zm-7.48-30.12a1.08,1.08,0,1,0-1.08,1.07A1.08,1.08,0,0,0,178.44,368.08Zm3.23,0a1.08,1.08,0,1,0-1.08,1.07A1.08,1.08,0,0,0,181.67,368.08Zm3.22,0a1.08,1.08,0,1,0-1.07,1.07A1.07,1.07,0,0,0,184.89,368.08Zm3.23,0a1.08,1.08,0,1,0-1.08,1.07A1.08,1.08,0,0,0,188.12,368.08Zm3.23,0a1.08,1.08,0,1,0-1.08,1.07A1.08,1.08,0,0,0,191.35,368.08Zm3.23,0a1.08,1.08,0,1,0-1.08,1.07A1.08,1.08,0,0,0,194.58,368.08Zm-16.14,8.6a1.08,1.08,0,1,0-1.08,1.08A1.07,1.07,0,0,0,178.44,376.68Zm3.23,0a1.08,1.08,0,1,0-1.08,1.08A1.08,1.08,0,0,0,181.67,376.68Zm3.22,0a1.08,1.08,0,1,0-1.07,1.08A1.07,1.07,0,0,0,184.89,376.68Zm3.23,0a1.08,1.08,0,1,0-1.08,1.08A1.07,1.07,0,0,0,188.12,376.68Zm3.23,0a1.08,1.08,0,1,0-1.08,1.08A1.07,1.07,0,0,0,191.35,376.68Zm3.23,0a1.08,1.08,0,1,0-1.08,1.08A1.08,1.08,0,0,0,194.58,376.68Zm-5.11,12.37a1.08,1.08,0,1,0-1.08,1.08A1.08,1.08,0,0,0,189.47,389.05Zm3.22,0a1.08,1.08,0,1,0-1.07,1.08A1.07,1.07,0,0,0,192.69,389.05Zm3.23,0a1.08,1.08,0,1,0-1.08,1.08A1.07,1.07,0,0,0,195.92,389.05Zm3.23,0a1.08,1.08,0,1,0-1.08,1.08A1.07,1.07,0,0,0,199.15,389.05Zm3.22,0a1.08,1.08,0,1,0-1.07,1.08A1.07,1.07,0,0,0,202.37,389.05Zm3.23,0a1.08,1.08,0,1,0-1.07,1.08A1.07,1.07,0,0,0,205.6,389.05Zm-16.13,8.88a1.08,1.08,0,1,0-1.08,1.08A1.09,1.09,0,0,0,189.47,397.93Zm3.22,0a1.08,1.08,0,1,0-1.07,1.08A1.08,1.08,0,0,0,192.69,397.93Zm3.23,0a1.08,1.08,0,1,0-1.08,1.08A1.08,1.08,0,0,0,195.92,397.93Zm3.23,0a1.08,1.08,0,1,0-1.08,1.08A1.08,1.08,0,0,0,199.15,397.93Zm3.22,0A1.08,1.08,0,1,0,201.3,399,1.08,1.08,0,0,0,202.37,397.93Zm3.23,0a1.08,1.08,0,1,0-1.07,1.08A1.08,1.08,0,0,0,205.6,397.93Z",
    style: {
      fill: "#51C4DF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.88,299.3h-3.76a.93.93,0,1,1,0-1.85h3.76a.93.93,0,1,1,0,1.85Zm.93,3.38a.93.93,0,0,0-.93-.93h-3.76a.93.93,0,1,0,0,1.86h3.76A.93.93,0,0,0,217.81,302.68Zm0,4.3a.93.93,0,0,0-.93-.93h-3.76a.93.93,0,0,0,0,1.86h3.76A.92.92,0,0,0,217.81,307Zm0,4.31a.92.92,0,0,0-.93-.93h-3.76a.93.93,0,1,0,0,1.85h3.76A.92.92,0,0,0,217.81,311.29Zm0,4.3a.93.93,0,0,0-.93-.93h-3.76a.93.93,0,0,0,0,1.86h3.76A.93.93,0,0,0,217.81,315.59Zm0,4.3a.93.93,0,0,0-.93-.93h-3.76a.93.93,0,0,0,0,1.86h3.76A.92.92,0,0,0,217.81,319.89Zm0,4.31a.92.92,0,0,0-.93-.93h-3.76a.93.93,0,1,0,0,1.85h3.76A.92.92,0,0,0,217.81,324.2Zm0,4.3a.93.93,0,0,0-.93-.93h-3.76a.93.93,0,0,0,0,1.86h3.76A.93.93,0,0,0,217.81,328.5Zm14.09-30.12a.93.93,0,0,0-.93-.93h-9.89a.93.93,0,0,0,0,1.85H231A.93.93,0,0,0,231.9,298.38Zm0,4.3a.93.93,0,0,0-.93-.93h-9.89a.93.93,0,0,0,0,1.86H231A.93.93,0,0,0,231.9,302.68Zm0,4.3a.93.93,0,0,0-.93-.93h-9.89a.93.93,0,0,0,0,1.86H231A.93.93,0,0,0,231.9,307Zm0,4.31a.93.93,0,0,0-.93-.93h-9.89a.93.93,0,0,0,0,1.85H231A.93.93,0,0,0,231.9,311.29Zm0,4.3a.93.93,0,0,0-.93-.93h-9.89a.93.93,0,0,0,0,1.86H231A.93.93,0,0,0,231.9,315.59Zm11.83,4.3a.93.93,0,0,0-.93-.93h-9.88a.93.93,0,1,0,0,1.86h9.88A.92.92,0,0,0,243.73,319.89Zm0,4.31a.92.92,0,0,0-.93-.93h-9.88a.93.93,0,1,0,0,1.85h9.88A.92.92,0,0,0,243.73,324.2Zm0,4.3a.93.93,0,0,0-.93-.93h-9.88a.93.93,0,1,0,0,1.86h9.88A.93.93,0,0,0,243.73,328.5Zm-7.48-30.12a1.08,1.08,0,1,0-1.08,1.07A1.08,1.08,0,0,0,236.25,298.38Zm3.22,0a1.08,1.08,0,1,0-1.07,1.07A1.07,1.07,0,0,0,239.47,298.38Zm3.23,0a1.08,1.08,0,1,0-1.07,1.07A1.07,1.07,0,0,0,242.7,298.38Zm3.23,0a1.08,1.08,0,1,0-1.08,1.07A1.08,1.08,0,0,0,245.93,298.38Zm3.23,0a1.08,1.08,0,1,0-1.08,1.07A1.08,1.08,0,0,0,249.16,298.38Zm3.22,0a1.08,1.08,0,1,0-1.07,1.07A1.07,1.07,0,0,0,252.38,298.38ZM236.25,307a1.08,1.08,0,1,0-1.08,1.08A1.07,1.07,0,0,0,236.25,307Zm3.22,0a1.08,1.08,0,1,0-1.07,1.08A1.07,1.07,0,0,0,239.47,307Zm3.23,0a1.08,1.08,0,1,0-1.07,1.08A1.07,1.07,0,0,0,242.7,307Zm3.23,0a1.08,1.08,0,1,0-1.08,1.08A1.07,1.07,0,0,0,245.93,307Zm3.23,0a1.08,1.08,0,1,0-1.08,1.08A1.07,1.07,0,0,0,249.16,307Zm3.22,0a1.08,1.08,0,1,0-1.07,1.08A1.07,1.07,0,0,0,252.38,307Zm-5.11,12.37a1.08,1.08,0,1,0-1.07,1.08A1.07,1.07,0,0,0,247.27,319.35Zm3.23,0a1.08,1.08,0,1,0-1.07,1.08A1.07,1.07,0,0,0,250.5,319.35Zm3.23,0a1.08,1.08,0,1,0-1.08,1.08A1.07,1.07,0,0,0,253.73,319.35Zm3.23,0a1.08,1.08,0,1,0-1.08,1.08A1.08,1.08,0,0,0,257,319.35Zm3.22,0a1.08,1.08,0,1,0-1.07,1.08A1.07,1.07,0,0,0,260.18,319.35Zm3.23,0a1.08,1.08,0,1,0-1.07,1.08A1.07,1.07,0,0,0,263.41,319.35Zm-16.14,8.88a1.08,1.08,0,1,0-1.07,1.08A1.08,1.08,0,0,0,247.27,328.23Zm3.23,0a1.08,1.08,0,1,0-1.07,1.08A1.08,1.08,0,0,0,250.5,328.23Zm3.23,0a1.08,1.08,0,1,0-1.08,1.08A1.08,1.08,0,0,0,253.73,328.23Zm3.23,0a1.08,1.08,0,1,0-1.08,1.08A1.09,1.09,0,0,0,257,328.23Zm3.22,0a1.08,1.08,0,1,0-1.07,1.08A1.08,1.08,0,0,0,260.18,328.23Zm3.23,0a1.08,1.08,0,1,0-1.07,1.08A1.08,1.08,0,0,0,263.41,328.23Z",
    style: {
      fill: "#51C4DF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.88,334.57h-3.76a.93.93,0,0,1,0-1.86h3.76a.93.93,0,0,1,0,1.86Zm.93,3.38a.92.92,0,0,0-.93-.93h-3.76a.93.93,0,1,0,0,1.85h3.76A.92.92,0,0,0,217.81,338Zm0,4.3a.93.93,0,0,0-.93-.93h-3.76a.93.93,0,0,0,0,1.86h3.76A.93.93,0,0,0,217.81,342.25Zm0,4.3a.93.93,0,0,0-.93-.93h-3.76a.93.93,0,1,0,0,1.86h3.76A.93.93,0,0,0,217.81,346.55Zm0,4.3a.92.92,0,0,0-.93-.92h-3.76a.93.93,0,1,0,0,1.85h3.76A.92.92,0,0,0,217.81,350.85Zm0,4.31a.93.93,0,0,0-.93-.93h-3.76a.93.93,0,1,0,0,1.86h3.76A.93.93,0,0,0,217.81,355.16Zm0,4.3a.93.93,0,0,0-.93-.93h-3.76a.93.93,0,1,0,0,1.86h3.76A.93.93,0,0,0,217.81,359.46Zm0,4.3a.92.92,0,0,0-.93-.92h-3.76a.93.93,0,1,0,0,1.85h3.76A.92.92,0,0,0,217.81,363.76Zm14.09-30.12a.93.93,0,0,0-.93-.93h-9.89a.93.93,0,0,0,0,1.86H231A.93.93,0,0,0,231.9,333.64Zm0,4.31A.93.93,0,0,0,231,337h-9.89a.93.93,0,0,0,0,1.85H231A.93.93,0,0,0,231.9,338Zm0,4.3a.93.93,0,0,0-.93-.93h-9.89a.93.93,0,0,0,0,1.86H231A.93.93,0,0,0,231.9,342.25Zm0,4.3a.93.93,0,0,0-.93-.93h-9.89a.93.93,0,0,0,0,1.86H231A.93.93,0,0,0,231.9,346.55Zm0,4.3a.93.93,0,0,0-.93-.92h-9.89a.93.93,0,0,0,0,1.85H231A.93.93,0,0,0,231.9,350.85Zm11.83,4.31a.93.93,0,0,0-.93-.93h-9.88a.93.93,0,0,0,0,1.86h9.88A.93.93,0,0,0,243.73,355.16Zm0,4.3a.93.93,0,0,0-.93-.93h-9.88a.93.93,0,1,0,0,1.86h9.88A.93.93,0,0,0,243.73,359.46Zm0,4.3a.92.92,0,0,0-.93-.92h-9.88a.93.93,0,1,0,0,1.85h9.88A.92.92,0,0,0,243.73,363.76Zm-7.48-30.12a1.08,1.08,0,1,0-1.08,1.08A1.07,1.07,0,0,0,236.25,333.64Zm3.22,0a1.08,1.08,0,1,0-1.07,1.08A1.07,1.07,0,0,0,239.47,333.64Zm3.23,0a1.08,1.08,0,1,0-1.07,1.08A1.07,1.07,0,0,0,242.7,333.64Zm3.23,0a1.08,1.08,0,1,0-1.08,1.08A1.07,1.07,0,0,0,245.93,333.64Zm3.23,0a1.08,1.08,0,1,0-1.08,1.08A1.07,1.07,0,0,0,249.16,333.64Zm3.22,0a1.08,1.08,0,1,0-1.07,1.08A1.07,1.07,0,0,0,252.38,333.64Zm-16.13,8.61a1.08,1.08,0,1,0-1.08,1.07A1.08,1.08,0,0,0,236.25,342.25Zm3.22,0a1.08,1.08,0,1,0-1.07,1.07A1.07,1.07,0,0,0,239.47,342.25Zm3.23,0a1.08,1.08,0,1,0-1.07,1.07A1.07,1.07,0,0,0,242.7,342.25Zm3.23,0a1.08,1.08,0,1,0-1.08,1.07A1.08,1.08,0,0,0,245.93,342.25Zm3.23,0a1.08,1.08,0,1,0-1.08,1.07A1.08,1.08,0,0,0,249.16,342.25Zm3.22,0a1.08,1.08,0,1,0-1.07,1.07A1.07,1.07,0,0,0,252.38,342.25Zm-5.11,12.37a1.08,1.08,0,1,0-1.07,1.08A1.08,1.08,0,0,0,247.27,354.62Zm3.23,0a1.08,1.08,0,1,0-1.07,1.08A1.08,1.08,0,0,0,250.5,354.62Zm3.23,0a1.08,1.08,0,1,0-1.08,1.08A1.08,1.08,0,0,0,253.73,354.62Zm3.23,0a1.08,1.08,0,1,0-1.08,1.08A1.09,1.09,0,0,0,257,354.62Zm3.22,0a1.08,1.08,0,1,0-1.07,1.08A1.08,1.08,0,0,0,260.18,354.62Zm3.23,0a1.08,1.08,0,1,0-1.07,1.08A1.08,1.08,0,0,0,263.41,354.62Zm-16.14,8.88a1.08,1.08,0,1,0-1.07,1.07A1.07,1.07,0,0,0,247.27,363.5Zm3.23,0a1.08,1.08,0,1,0-1.07,1.07A1.07,1.07,0,0,0,250.5,363.5Zm3.23,0a1.08,1.08,0,1,0-1.08,1.07A1.08,1.08,0,0,0,253.73,363.5Zm3.23,0a1.08,1.08,0,1,0-1.08,1.07A1.08,1.08,0,0,0,257,363.5Zm3.22,0a1.08,1.08,0,1,0-1.07,1.07A1.07,1.07,0,0,0,260.18,363.5Zm3.23,0a1.08,1.08,0,1,0-1.07,1.07A1.07,1.07,0,0,0,263.41,363.5Z",
    style: {
      fill: "#51C4DF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.91,278.32s-13.86,10-21.23,24.27-14.3,46.36-23.39,61.52S269,390.54,260.29,397s-21.66,10.83-29,12.13-27.3,3.47-27.3,3.47l.87,16.46s16.9.44,49-2.6,71.06-26.43,71.06-26.43l-1.3,48.1H435.33s6.93-68.46,3.47-103.56S415.4,284,398.5,274.42s-34.66-7.36-45.49-6.5S330.91,278.32,330.91,278.32Z",
    style: {
      fill: "#616161"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.5,274.42c-12-6.78-24.49-7.64-34.58-7.26l-22.81,36.72S367.5,290,375,288s23,4.5,27.5,21,6,80,7.5,98.5-6.5,33.5-9,36c-1.16,1.16-3.3,2.87-4,4.67h38.33s6.93-68.46,3.47-103.56S415.4,284,398.5,274.42Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.9,404.27c-20.95-.64-15.95-28.13-21.46-43.58s-5.64-41.73,15.74-42.2,25,29,28.34,44.36S366.85,404.91,345.9,404.27Zm-19.64-43.72c5.25,13.58.9,40.76,19.94,41.22s23.86-24.52,20.82-39-7.41-42.07-26.79-41.72S321,347,326.26,360.55Zm26.28-31.62c-2.28,7-4.18,14.1-6.1,21.22.95,1.82,2,3.48,2.89,5.37a50.52,50.52,0,0,1,2,6c4.89.32,9.75.78,14.65,1C362.93,351.61,360,337.64,352.54,328.93Zm-13,21c-2.95-7.31-6.41-14.36-9.92-21.41-7.33,9.81-6.24,21.25-1.48,31.95a50,50,0,0,1,10.59.31C338.08,357.05,337.61,353.3,339.57,349.91Zm8.2,23.63c-2.26,2-4,2.19-5.6-.54a189.09,189.09,0,0,1-5.9,21.42c5.85,7,14.84,7.18,21.15.54C353.85,387.77,350,381.32,347.77,373.54Zm.19-12.19c-.38-2.61-1.43-7.82-4.93-8s-3.18,5.56-2.67,7.86.9,8.46,4.15,8.56S348.34,364,348,361.35Z",
    style: {
      fill: "#51C4DF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.5,357.5s-6-23-5.5-12.5,1,35-10.5,48S283,402.5,274,408c-5.18,3.17-19.4,12-30.28,19.39,3.17-.26,6.52-.55,10.07-.89,32.06-3,71.06-26.43,71.06-26.43l-.16,5.82C325.2,400.72,326.15,383.26,319.5,357.5Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.28,395.74s-1.73-39.43-14.73-62.82",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M330.91,278.32s-13.86,10-21.23,24.27-14.3,46.36-23.39,61.52S269,390.54,260.29,397s-21.66,10.83-29,12.13-27.3,3.47-27.3,3.47l.87,16.46s16.9.44,49-2.6,71.06-26.43,71.06-26.43l-1.3,48.1H435.33s6.93-68.46,3.47-103.56S415.4,284,398.5,274.42s-34.66-7.36-45.49-6.5S330.91,278.32,330.91,278.32Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.35,425s-7.9-12.39-13.88-18.8-22.43-1.92-28.62-1.07-19.87,9.4-22.43,10.68,1.07,4.06,4.7,4.91,7.47-2.56,11.1-3.2,2.35,1.07,7.48,5.13,7.05,7.9,15.38,9.82a45.88,45.88,0,0,0,23.28-1.07C222.92,429.47,220.35,425,220.35,425Z",
    style: {
      fill: "#263238",
      stroke: "#616161",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.79,420.93s-6.84.64-10.68,2.77-4.7,7.05-2.35,8.12,9.61,1.71,14.31-.21,4.49-4.27,3.42-7.69S217.79,420.93,217.79,420.93Z",
    style: {
      fill: "#263238",
      stroke: "#616161",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.6,401.28s-5.76-2.35-8.75-.43-4.06,4.06-3.85,7.9-1.71,11.32-2.13,14.95,1.06,4.49,3.84,4.92,4.06-1.92,5.13-5.34,3.41-13.89,4.7-16.45A12.05,12.05,0,0,0,186.6,401.28Z",
    style: {
      fill: "#263238",
      stroke: "#616161",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.92,402.34s-2.13-3.84-5.55-3.84-7.47,0-7.69,3-2.13,14.95-4.27,19.65.64,7.48,3.84,7.48,3.42-.43,6.41-5.56,5.13-14.95,5.13-14.95",
    style: {
      fill: "#263238",
      stroke: "#616161",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.6,409.18s-2.56-7.05-6.4-7.69-6.84-.43-7,3.63-.86,12-3.42,16.66-4.7,6.84-1.49,7.91,5.34,1.28,7.9-1.5,6.41-14.95,6.41-15.59",
    style: {
      fill: "#263238",
      stroke: "#616161",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.77,207.49s1.76,21.22,1.32,39.79S297.34,279.12,308,286.2s20.34,10.61,24.76,13.26a21.28,21.28,0,0,1,6.63,6.19s4.87-7.07,12.83-10.17S373,282.66,375.6,271.6s-2.65-34.49-30.06-52.17S285,203.06,285,203.06Z",
    style: {
      fill: "#474747",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.37,208.18s0,18.7,1,22.64,7.55,22.63,9.19,27.88,14.43,28.53,17.38,32.14,15.74-5.25,15.74-5.25l7.22,15.75s15.59-25.88,19.2-32.12,5.65-13.12,3-23-2.88-10.2-19.28-18.07-40.34-17.05-44.93-20.33S290,205.89,289.37,208.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.11,246.26c-2.63-9.84-2.88-10.2-19.28-18.07-5.17-2.48-11.1-5.1-16.93-7.62,6.75,9.61,19.54,28.63,21.26,37.21,2.34,11.73-10.56,23.07-22.29,28.94-3.52,1.76-6,3.17-7.79,4.27,2.57,2.55,11.07-2.48,14.31-4.56l21.24-15.74a6.63,6.63,0,0,1,3.95,2.77c1.06-1.78,1.93-3.25,2.5-4.24C362.68,263,364.73,256.1,362.11,246.26Z",
    style: {
      fill: "#51C4DF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.11,246.26c-2.63-9.84-2.88-10.2-19.28-18.07-5.17-2.48-11.1-5.1-16.93-7.62,6.75,9.61,19.54,28.63,21.26,37.21,2.34,11.73-10.56,23.07-22.29,28.94-3.52,1.76-6,3.17-7.79,4.27,2.57,2.55,11.07-2.48,14.31-4.56l21.24-15.74a6.63,6.63,0,0,1,3.95,2.77c1.06-1.78,1.93-3.25,2.5-4.24C362.68,263,364.73,256.1,362.11,246.26Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M289.37,208.18s0,18.7,1,22.64,7.55,22.63,9.19,27.88,14.43,28.53,17.38,32.14,15.74-5.25,15.74-5.25l7.22,15.75s15.59-25.88,19.2-32.12,5.65-13.12,3-23-2.88-10.2-19.28-18.07-40.34-17.05-44.93-20.33S290,205.89,289.37,208.18Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.68,206.9s-6.64,5.31-8,13.94,1.33,9.95,5.31,6a77.9,77.9,0,0,0,7.31-8.63s-3.32,5.31,1.32,6.64,13.94-4,17.26-5.31S310.93,194.28,291.68,206.9Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.66,236.39s2,3.61,13.45,5.91,26.9,1.64,31.82.32a138.27,138.27,0,0,0,13.45-4.92s2.95-.32,2.62,2.3-7.54,3.94-7.54,3.94-1.64,10.16-4.6,13.12S323.15,262,316.92,261s-8.2-10.17-9.18-11.48-2-3.28-3.94-3.28-2,7.22-1.64,10.83.66,1.64-2.62,1.64-8.53-3.61-9.19-11.16S288.06,236.72,291.66,236.39Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.7,247.56s1.41,8.43,5.27,9.84,4.57,1.4,10.54-3.52,13.71-3.16,13.71-3.16,4.22-4.57,4.22-6.32-1.41-1.06-1.41-1.06-2.65,1.72-14.43,2.28c-4.21.2-18.25-.87-18.25-.87Z",
    style: {
      fill: "#51C4DF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.93,243l.11,3.48a4.93,4.93,0,0,1-3.81,4.26,13.51,13.51,0,0,1-7.07.11s-1.35-9.87-1.35-11a2.27,2.27,0,0,1,.45-1.57S293.74,242.26,301.93,243Z",
    style: {
      fill: "#51C4DF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.11,253a2.18,2.18,0,1,1-2.11-1.62A1.91,1.91,0,0,1,340.11,253Z",
    style: {
      fill: "#51C4DF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.14,247.87s-2.29,16.07-3.6,20.34,11.15,2.29,15.08,1.64",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.66,285.59a181.23,181.23,0,0,0,17.06-12.13",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,241s1.61-6.43,18.36-5.09",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.85,239.34s-3.28-5.57-8.53-5.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.35 305.65 334.63 328.23 341.19 329.21 339.35 305.65",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.42,206.8s29.32,17,48.77,25.45,44.22,21.67,46,32.72-10.61,21.23-15.47,25.2-14.6,13.71-14.6,13.71,23.88-13.26,32.28-19.45,11.5-16.81,8-35.82-5.75-48.2-16.36-64.56-36.7-7.52-55.71.88A125.47,125.47,0,0,0,276.42,206.8Z",
    style: {
      fill: "#616161"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.76,210.08S322.13,221,337,228.85s33.23,19.55,37.54,26.2,3.12,10.55-.79,17.59-9,10.95-3.52,11.34,10.95-10.17,10.95-18.77-1.56-17.2-3.91-31.67-9-43-15.64-50-18.37-5.86-30.49,2.35,11.33,12.12,9,18.38c-1.67,4.43-11.91.09-14.68-.7-9.34-2.66-13.68-2.26-22.75,1.48C299.94,206.13,301.91,209,303.76,210.08Z",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M276.42,206.8s29.32,17,48.77,25.45,44.22,21.67,46,32.72-10.61,21.23-15.47,25.2-14.6,13.71-14.6,13.71,23.88-13.26,32.28-19.45,11.5-16.81,8-35.82-5.75-48.2-16.36-64.56-36.7-7.52-55.71.88A125.47,125.47,0,0,0,276.42,206.8Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395,294.79s-13,0-20.8,21.23-16.46,75-16.46,75-19.07,14.74-33.37,21.67A250.61,250.61,0,0,1,300.15,423s6.68,13.46,6.07,18.63c-.22,1.83,2.15,4.38,2.15,4.38s36-2.65,56.34-6.55,45.49-13,49-31.63,17.73-60.29,12.1-71.56",
    style: {
      fill: "#616161"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395,294.79a13.65,13.65,0,0,0-5.16,1.4l.12,1.31s7-.5,13.5,9.5,4.5,17.5,6.5,42.5.5,48.5-4,48.5-17.5-5.5-15.5-2.5,5,5.5,5,9.5-9.5-7.5-12-7.5-1,1.5.5,10,0,1.5-16,6.5-41,24-47.5,26.5c-4.16,1.6-10.35,4.22-14.28,5.9v.47s38.12-3.47,58.49-7.37,45.49-13,49-31.63,17.76-61.52,12.13-72.79Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.38,392.27s15.16,1.74,22.53,10.84",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.81,393.57s10.4-.43,16.9,10.84",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M395,294.79s-13,0-20.8,21.23-16.46,75-16.46,75-19.07,14.74-33.37,21.67A250.61,250.61,0,0,1,300.15,423s6.68,13.46,6.07,18.63c-.22,1.83,2.15,4.38,2.15,4.38s36-2.65,56.34-6.55,45.49-13,49-31.63,17.73-60.29,12.1-71.56",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.94,434.06a16.28,16.28,0,0,0-2.31-5.9c-1.23-1.91-2.94-4.25-4.45-5.13-2.71-1.58-8.35.22-12.19.67s-5.42-1.8-12.87-7.67-40.41-9.93-44.7-9.93-8.35,2.25-16,2.7-9.94,2.71-4.07,6.33,14,2.25,19.42.67,9.7,7,11.28,7,.23,1.58-2.7,2.48-9.94,0-14.23.23-10.38,5.42-7.9,7.22,8.81,1.58,15.8,1.58,18.52-.9,21-.45,9,5.2,18.74,8.58a34.63,34.63,0,0,0,19.41.68c1.36-.23,9.71,3.84,14.22,2.93C311.53,445.42,310.72,438.31,309.94,434.06Z",
    style: {
      fill: "#263238",
      stroke: "#616161",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.07,403.39S246.29,400,242.45,400s-5,3.84-5,7.45a97.07,97.07,0,0,1-2,16.48c-.91,3.16.9,5.42,5,4.74s7.23-16.48,7.9-20.32,4.75-2,6.1-2.93S253.07,403.39,253.07,403.39Z",
    style: {
      fill: "#263238",
      stroke: "#616161",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.93,406.55s-5.42-4.74-9.25-5.2-7.9,1.13-8.81,4.75-.45,11.06-1.8,14.67-4.74,8.58-1.58,9.26a7.15,7.15,0,0,0,7.45-2.49c2-2.26,5.19-7.9,7.45-11.51S265.93,406.55,265.93,406.55Z",
    style: {
      fill: "#263238",
      stroke: "#616161",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.35,423.93s-4.07-10.84-10.61-14.9S263,403.61,261,407.68s-2.71,10.38-5.87,15.57-2,6.78,2.48,6.32,6.55-6.54,9.71-10.61,3.38-2.93,3.38-2.93",
    style: {
      fill: "#263238",
      stroke: "#616161",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-1--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.58,
    y: 438.35,
    width: 7.79,
    height: 2.6,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.54,
    y: 438.35,
    width: 7.79,
    height: 2.6,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.51,
    y: 438.35,
    width: 7.79,
    height: 2.6,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.47,
    y: 438.35,
    width: 7.79,
    height: 2.6,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.44,
    y: 438.35,
    width: 7.79,
    height: 2.6,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.4,
    y: 438.35,
    width: 7.79,
    height: 2.6,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.37,
    y: 438.35,
    width: 7.79,
    height: 2.6,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.33,
    y: 438.35,
    width: 7.79,
    height: 2.6,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.3,
    y: 438.35,
    width: 7.79,
    height: 2.6,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.26,
    y: 438.35,
    width: 7.79,
    height: 2.6,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.23,
    y: 438.35,
    width: 7.79,
    height: 2.6,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.19,
    y: 438.35,
    width: 7.79,
    height: 2.6,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.16,
    y: 438.35,
    width: 7.79,
    height: 2.6,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.12,
    y: 438.35,
    width: 7.79,
    height: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.09,
    y: 438.35,
    width: 7.79,
    height: 2.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.09,
    y: 440.54,
    width: 169.29,
    height: 4.73,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.63,
    y: 440.54,
    width: 56.75,
    height: 4.73,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.98 387.04 95.48 387.04 66.28 261.04 176.78 261.04 205.98 387.04",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.48 387.04 88.98 387.04 59.78 261.04 170.28 261.04 199.48 387.04",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.1,337.54H118.88L97,440.17a4.46,4.46,0,0,0,4.35,5.37h67.24l-3.25-3.25H128.65a2.31,2.31,0,0,1-2.27-2.73Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.37,445.54H123a2.34,2.34,0,0,1,0-1l21.73-107H118.88L97,440.17A4.46,4.46,0,0,0,101.37,445.54Z",
    style: {
      fill: "#616161",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.38,
    y: 444.87,
    width: 400,
    height: 9.33,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.52,
    y: 444.87,
    width: 123.86,
    height: 9.33,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingImage);
export default __webpack_public_path__ + "static/media/landingImage.32e2b5e9a02cceda74bebe167e439eb1.svg";
export { ForwardRef as ReactComponent };